import React from "react";

import KeyboardArrowDownRounded from "@mui/icons-material/KeyboardArrowDownRounded";
import { Menu } from "@mui/material";

import { RollupFilterOption } from "@app/analytics/providers/RollupContext";
import { ELLIPSIS_SX } from "@app/common/styles";
import useAnchorElement from "@app/utils/hooks/useAnchorElement";

import { DropdownMenuItem } from "@rui/Dropdown";

import RollupFilterIcon from "./RollupFilterIcon";
import { FilterDropdownButton } from "./styles";

interface FilterDropdownProps {
  id: string;
  options: RollupFilterOption[];
  selected: RollupFilterOption;
  onChange: (newValue: RollupFilterOption) => void;
  icon: React.FunctionComponent;
  disabled?: boolean;
}

const FilterDropdown = ({
  id,
  options,
  selected,
  onChange,
  icon,
  disabled,
}: FilterDropdownProps) => {
  const { anchorElement, open, onClick, onClose, width } = useAnchorElement();

  const handleChange = (newOption: RollupFilterOption) => {
    onChange(newOption);
    onClose();
  };

  const disableDropdown = disabled || options.length <= 1;

  return (
    <>
      <FilterDropdownButton
        disabled={disableDropdown}
        aria-controls={open ? id : undefined}
        aria-haspopup
        aria-expanded={open ? "true" : undefined}
        onClick={onClick}
        startIcon={<RollupFilterIcon icon={icon} />}
        endIcon={disabled ? undefined : <KeyboardArrowDownRounded />}
      >
        <span className="filter-dropdown__label">{selected.label}</span>
      </FilterDropdownButton>
      <Menu
        id="reports-pagination-menu"
        anchorEl={anchorElement}
        open={open}
        onClose={onClose}
        sx={{
          "& .MuiPaper-root": {
            minWidth: width,
            boxShadow: (theme) => theme.shadows[4],
          },
        }}
      >
        {options.map((opt) => {
          const isSelected = opt.id === selected.id;
          return (
            <DropdownMenuItem
              key={opt.id}
              onClick={() => handleChange(opt)}
              sx={{ minWidth: "80px", ...ELLIPSIS_SX }}
              selected={isSelected}
              label={opt.label}
            />
          );
        })}
      </Menu>
    </>
  );
};

export default FilterDropdown;
